
<!-- filters -->
<div class="d-flex justify-content-between pt-2">
  <div class="wild_search_all">
    <div class="filter_box">
      <input
        [(ngModel)]="searchText"
        type="text"
        id="uni"
        class="textFilter f-12 poppins-regular"
        [placeholder]="search_placeholder"
        (keyup)="universalSearch(searchText)"
      />
      <img src="assets/Serina Assets/new_theme/bx-search.svg" alt="search" width="15" height="15" />
    </div>
    <div class="calender_div">
      <p-calendar
        #datePicker
        [(ngModel)]="rangeDates"
        selectionMode="range"
        [minDate]="minDate"
        [maxDate]="maxDate"
        placeholder=""
        [readonlyInput]="true"
        [showIcon]="true"
        showButtonBar="true"
        (onClearClick)="clearDates()"
        (onSelect)="filterByDate(rangeDates)"
        inputId="range"
      ></p-calendar>
    </div>
    <div class="pending ml-2" *ngIf="heading?.includes('Vendor')">
      <span class="mr-2">Pending with</span>
      <p-dropdown
        [options]="pendingWithList"
        [(ngModel)]="selectedPendingWith"
        (onChange)="onSelectOwner($event)"
        placeholder="Select owner"
        [showClear]="true"
        appendTo="body">
      </p-dropdown>
    </div>
  </div>

  <div class="d-flex align-items-center">
    <!-- search by Requestor -->
    <div class="status" *ngIf="heading?.includes('Vendor')">
      <!-- <label class="f-12 png_label"> Search by PO requestor </label> -->
      <p-multiSelect
        [options]="requestorNameList"
        [(ngModel)]="selectedRequestorNameList"
        (onChange)="onSelectRequestor($event)"
        placeholder="Search by PO Requester"
        optionLabel=""
        [maxSelectedLabels]="3"
        [selectedItemsLabel]="'{0} items selected'"
        name="requestor"
        appendTo="body"
      >
      </p-multiSelect>
      <!-- <p-autoComplete
        (onSelect)="onSelectRequestor($event)"
        placeholder="Ex: abc@xyz.com"
        [suggestions]="filteredRequestorList"
        (completeMethod)="filterByRequestor($event)"
        field=""
        [dropdown]="true"
      >
        <ng-template let-vendor pTemplate="item">
          <div class="">
            <div class="f-12">{{ vendor }}</div>
          </div>
        </ng-template>
      </p-autoComplete> -->
    </div>

    <div
      class="totalExc f-12"
      *ngIf="
        (user_access == 'receiver' || user_access == 'vendor super user') &&
        !router.url.includes('Service_ExceptionManagement') &&
        isMyView
      "
    >
      <input
        id="all"
        type="checkbox"
        [checked]="ds.exceptionByUserBool"
        (change)="onSelectAll($event.target.checked)"
        class="mr-2"
      />
      <label for="all" class="m-0">My View</label>
    </div>

    <!-- search by Status -->
    <!-- <div class="filter status" *ngIf="!router.url.includes('approvalPending')">
      <label class="f-12 png_label"> Search by Status </label>
      <p-autoComplete
        (onSelect)="onSelectStatus($event)"
        placeholder="Please Select Status"
        [suggestions]="filteredStatusList"
        (completeMethod)="filterByStatus($event)"
        field="name"
        [dropdown]="true"
        [(ngModel)]="selected_status_obj"
      >
        <ng-template let-status pTemplate="item">
          <div class="">
            <div class="f-12">{{ status.name }}</div>
          </div>
        </ng-template>
      </p-autoComplete>
    </div> -->

    <button class="secondarybtn f-18" (click)="exportExcel()">
      <img src="assets/Serina Assets/new_theme/download.svg" alt="download" />
    </button>
  </div>
</div>

<div class="pt-2" [ngSwitch]="viewType">
  <!-- All Tab -->
  <div *ngSwitchCase="'normal'">
    <app-exception-table
      [invoiceColumns]="ColumnsForBatch"
      [columnsToDisplay]="columnsToDisplay"
      [showPaginatorAllInvoice]="showPaginatorAllInvoice"
      [ColumnLength]="batchProcessColumnLength"
      (searchInvoiceData)="searchInvoiceDataV($event)"
      [columnsData]="columnsData"
      [searchText]="searchText"
      [pageId]="'exc_v'"
      [pageNumber]="pageNumber"
      (filterDataEmit)="filterEmit($event)"
      (paginationEvent)="paginate($event)"
    >
    </app-exception-table>
  </div>

  <ngx-spinner
    bdColor="rgba(251, 251, 251, 0.8)"
    size="medium"
    color="#070900"
    [fullScreen]="false"
    type="ball-spin-clockwise"
  >
    <p style="color: rgb(0, 0, 0)"></p>
  </ngx-spinner>
</div>
<p-toast></p-toast>

<p-dialog
  header="Select user preferences"
  [(visible)]="userSidebar"
  position="right"
  [modal]="true"
  [style]="{ width: '360px', height: '100vh', margin: '0px' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <div class="dialogContent mt-3 mb-3" style="gap: 10px">
    <!-- search by Requestor -->
    <div class="filterDialog status" *ngIf="heading.includes('Vendor')">
      <label class="f-12 png_label"> Choose requestor </label>
      <!-- <p-autoComplete
        (onSelect)="onSelectRequestor($event)"
        placeholder="Ex: abc@xyz.com"
        [suggestions]="filteredRequestorList"
        (completeMethod)="filterByRequestor($event)"
        field=""
        [dropdown]="true"
      >
      </p-autoComplete> -->
      <p-multiSelect
        [options]="requestorNameList"
        placeholder="Ex: abc@xyz.com"
        optionLabel=""
        [maxSelectedLabels]="3"
        [selectedItemsLabel]="'{0} items selected'"
        name="requestor"
        appendTo="body"
      >
      </p-multiSelect>
    </div>

    <div class="filterDialog status" *ngIf="heading.includes('Vendor')">
      <label class="f-12 png_label"> Choose Department </label>
      <!-- <p-autoComplete
        (onSelect)="onSelectRequestor($event)"
        placeholder="Search department..."
        [suggestions]="filteredRequestorList"
        (completeMethod)="filterByRequestor($event)"
        field=""
        [dropdown]="true"
      >
      </p-autoComplete> -->
      <p-multiSelect
        [options]="requestorNameList"
        placeholder="Ex: abc@xyz.com"
        optionLabel=""
        [maxSelectedLabels]="3"
        [selectedItemsLabel]="'{0} items selected'"
        name="requestor"
        appendTo="body"
      >
      </p-multiSelect>
    </div>

    <div class="filterDialog status" *ngIf="heading.includes('Vendor')">
      <label class="f-12 png_label"> Select the status list </label>
      <!-- <p-autoComplete
        (onSelect)="onSelectStatus($event)"
        placeholder="Search status..."
        [suggestions]="filteredStatusList"
        (completeMethod)="filterByStatus($event)"
        field="status"
        [dropdown]="true"
      >
      </p-autoComplete> -->

      <p-multiSelect
        [options]="statusInfo"
        ngModel
        (onChange)="onSelectStatus($event)"
        placeholder="Search status..."
        inputStyleClass="form-control inputBox inputForm selectpicker"
        optionLabel="status"
        [maxSelectedLabels]="3"
        [selectedItemsLabel]="'{0} items selected'"
        name="status"
      >
      </p-multiSelect>
    </div>
  </div>

  <div class="d-flex justify-content-center mt-5" mat-dialog-actions>
    <button
      class="secondary_btn f-12 mr-2"
      type="button"
      (click)="userSidebar = false"
    >
      Cancel
    </button>
    <button class="primary_btn f-12" cdkFocusInitial>Save</button>
  </div>
</p-dialog>
